import React from "react";
import home from "../../../../Assets/Images/selfhome.png";
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";

export default function FourQuadrants({ apiData, previewData, reportType, pageNumber }) {

  const styles = {
    pageWrapper: {
      backgroundColor: "rgb(255, 255, 255)",
      margin: "0 auto",
    },
    contents: {
      padding: "16px 0px",
    },
    containers: {
      display: "flex",
      flexDirection: "row",
      gap: "16px",
      marginBottom: "5px"
    },

    img: {
      height: "108px",
      width: "108px"
    },
    heading: {
      fontFamily: "Helvetica",
      fontWeight: 700,
      fontStyle: "Bold",
      fontSize: "18px",
      lineHeight: "24px",
      letterSpacing: "0px",
      textTransform: "uppercase",
      color: "#00577D",
      padding: "0px 0px 16px",
      margin: "0px"
    },
    paragraph: {
      fontFamily: "Helvetica",
      fontWeight: 400,
      fontStyle: "Regular",
      fontSize: "10px",
      lineHeight: "14px",
      letterSpacing: "0px",
      color: "#000000",
      marginTop: 0,
      marginBottom: "12px",
    },
    paragraphMain: {
      fontFamily: "Helvetica",
      fontWeight: 700,
      fontStyle: "Regular",
      fontSize: "10px",
      lineHeight: "14px",
      letterSpacing: "0px",
      color: "#000000",
      marginTop: 0,
      marginBottom: "12px",
    },
    label: {
      fontFamily: "Helvetica",
      fontWeight: 700,
      fontStyle: "Bold",
      fontSize: "10px",
      lineHeight: "14px",
      letterSpacing: "0px",
      color: "#000000",
    },
    boldParagraph: {
      fontFamily: "Helvetica",
      fontWeight: 400,
      fontSize: "10px",
      lineHeight: "14px",
      letterSpacing: "0px",
      color: "#000000",
      marginTop: 0,
      marginBottom: "16px",
    },
  };
  return (
    <div style={{ backgroundColor: "rgb(255, 255, 255)" }}>
      <HeaderPreview apiData={apiData} />
      <div style={styles.contents}>
        <h2 style={styles.heading}>
          STARTER QUADRANT
        </h2>
        <p style={styles.paragraphMain}>We all have a natural home base. It’s the quadrant we move from most often—the place that feels most familiar when we lead, relate, and make decisions. </p>
        <div style={styles.containers}>
          <img src={home} style={styles.img} />
          <div>
            <p style={styles.paragraph}>Your Starter Quadrant (Heart, Soul, Mind, or Strength™) reflects your most instinctive way of being. It’s shaped by your wiring, experiences, and the roles you’ve played. This insight helps you understand how you naturally show up at work, in relationships, and under pressure.  </p>
            <p style={styles.paragraph}>For individuals, it brings clarity to how you lead and grow. For teams and companies, it builds stronger collaboration, better communication, and a leadership culture rooted in authenticity. </p>
          </div>
        </div>
        <p style={styles.paragraph}>All four quadrants are part of who you are. But knowing your starting point helps you grow with purpose and lead with greater impact.        </p>

        <p style={styles.boldParagraph}>
          <span style={styles.label}>HEART:</span> This quadrant describes the emotive center of our being—that part of us that feels, values, wills, and connects with others. We discover who we are, what we want, and who we want to relate to from this inner space. From this dimension, we build social constructs, find our tribe, and build a life with and for others. It answers the core question of <i>Who</i>. Collaborative Leadership is the style associated with Heart.
        </p>
        <p style={styles.boldParagraph}>
          <span style={styles.label}>SOUL:</span> This is the meaning center of our being—the part of us that seeks to make sense of our lives, our stories, and our purpose in the world. From this space, we dream, imagine, and create. We cast a vision for our lives, families, and business enterprises and then inspire ourselves and others toward that desired future. This quadrant answers the core question of <i>Why</i>. Visionary Leadership is the style associated with Soul.
        </p>
        <p style={styles.boldParagraph}>
          <span style={styles.label}>MIND:</span> This dimension describes the strategic center of our being—that part of us that organizes and structures our inner and outer worlds into intelligible systems. From this space, we seek to understand reality and sort it into logical connections that make sense and provide coherence and safety for ourselves and others. From the mind, we build and attach ourselves to theories and truths that give a container to hold our way of being in the world. This quadrant answers the core question of <i>What</i>. Strategic Leadership is the style associated with Mind.
        </p>
        <p style={styles.boldParagraph}>
          <span style={styles.label}>STRENGTH:</span> This quadrant describes the sensory center of our being—that part of us that allows us to absorb the tactile data around us and convert that information into action. We experience and engage the physical world from this space, gathering resources and adopting behaviors for accomplishing goals. This quadrant is anchored in our bodies and, as such, is distinct from the other three internal dimensions of self. It answers the core question of <i>How</i>. Performance Leadership is the style associated with Strength.
        </p>
      </div>
      <FooterPreview reportType={reportType} pageNumber={pageNumber} />

    </div>

  );
}
